import { Page } from '@app/components/page/Page';
import { useStations } from '@app/core/stations/hooks/useStations';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { AdminIcon } from '../../AdminIcon';
import { fetchUsers } from '../../api';
import { CoreAdministrationSection } from './sections/CoreAdministrationSection';
import { FeatureConfigurationSection } from './sections/FeatureConfigurationSection';
import { SocialIntegrationsSection } from './sections/SocialIntegrationsSection';

export function AdminDashboardPage() {
  const stations = useStations();

  const users = useQuery({
    queryKey: ['users', 'count'],
    queryFn: () => fetchUsers({ size: 1 }),
  });

  const { $t } = useIntl();

  const title = $t({
    id: 'admin.dashboard.title',
    defaultMessage: 'Administración',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<AdminIcon />} title={title} />
      <Page.Content>
        <CoreAdministrationSection
          stationsCount={stations.length}
          usersCount={users.data?.metadata.totalCount ?? null}
        />
        <FeatureConfigurationSection />
        <SocialIntegrationsSection />
      </Page.Content>
    </Page>
  );
}
